import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';

const BackButtonHandler: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const entryPoints = new Set(['/','/dashboard']);

    const listener = CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      const currentPath = globalThis.location.pathname;

      if (entryPoints.has(currentPath)) {
        CapacitorApp.exitApp();
        return;
      }

      if (canGoBack) {
        navigate(-1);
      } else {
        navigate('/');
      }
    });

    return () => {
      listener.then(l => l.remove());
    };
  }, []); //  register once only

  return null;
};

export default BackButtonHandler;
 